module.exports = __webpack_public_path__ + "img/流星2.b73c98cf.png";